import React, { useState, useEffect } from 'react'
import styles from './style.module.scss'
import closeIcon from 'assets/images/inline_svg/button-close-16.svg'
import categoryIcon from 'assets/images/contacts/Editor/editor-category-20.svg'
import SVG from 'react-inlinesvg'
import { useTranslation } from 'react-i18next'

interface CategoryItemProps {
  category: any
  onDelete: () => void
}

const CategoryItem = ({ category, onDelete }: CategoryItemProps) => {
  return (
    <div
      className={styles.categoryItem}
      style={
        {
          '--category-color': '#' + category.color,
          '--category-bg-color': '#' + category.color + '22',
        } as React.CSSProperties
      }
    >
      <div className={styles.categoryName}>{category.name}</div>
      <SVG
        src={closeIcon}
        onClick={onDelete}
        style={{ cursor: 'pointer' }}
        {...({ alt: 'close' } as any)}
      />
    </div>
  )
}

interface CategoryProps {
  editData: any
  onDelete: (index: number) => void
  onAddItem: () => void
}

const Category = ({ editData, onDelete, onAddItem }: CategoryProps) => {
  const { t } = useTranslation()
  const [categoryList, setCategoryList] = useState(editData.categories)

  useEffect(() => {
    setCategoryList(editData.categories)
  }, [editData.categories])

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <img src={categoryIcon} alt="category icon" />
      </div>
      <div className={styles.categoryContainer}>
        {categoryList && categoryList.length > 0 && (
          <div className={styles.categorise}>
            {categoryList.map((category: any, index: number) => (
              <CategoryItem
                key={category.id + '-' + index}
                category={category}
                onDelete={() => onDelete(index)}
              />
            ))}
          </div>
        )}
        <div className={styles.addButton} onClick={onAddItem}>
          {t('contact.menu.addCategory')}
        </div>
      </div>
    </div>
  )
}

export default Category
